import React from 'react'
import './Footer.css'
import { NavLink } from 'react-router-dom'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="footer-div">
                <div className="quicklinkdiv">
                    <h2>Quick Links</h2>
                    <ul>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/">Home</NavLink>
                        </li>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/cot">COT Reports</NavLink>
                        </li>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/cot/futures">COT Futures</NavLink>
                        </li>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/cot/legacy-futures">COT Legacy Futures</NavLink>
                        </li>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/help">Help</NavLink>
                        </li>
                        <li className="quicklink">
                            <NavLink className="nav-link" aria-current="page" to="/about">About</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="contact">
                    <h2>Contact US</h2>
                    <div className="contactlink">Email : <span className="contactanswer">tradingster.com@gmail.com</span></div>
                    <div className="contactlink">Newsletter : <span className="contactanswer">Subscribe</span></div>
                    <div className="socialdiv">
                        <img src="./twitter.png" alt="" className="socialimg" />
                    </div>
                </div>
            </div>
            <p>© Copyright by Tradingster.com. All rights reserved. | Privacy Policy |</p>
        </div>
    )
}

export default Footer